const translations = {
  // ─── Navigation ────────────────────────────────────────
  "nav.home": {
    en: "Home",
    fr: "Accueil",
  },
  "nav.features": {
    en: "Features",
    fr: "Fonctionnalités",
  },
  "nav.pricing": {
    en: "Pricing",
    fr: "Tarifs",
  },
  "nav.support": {
    en: "Support",
    fr: "Support",
  },
  "nav.signUp": {
    en: "Sign Up",
    fr: "S'inscrire",
  },
  "nav.signIn": {
    en: "Sign In",
    fr: "Se connecter",
  },

  // ─── Hero / Baseline ──────────────────────────────────
  "hero.title": {
    en: "Never lose track of your UX insights again.",
    fr: "Ne perdez plus jamais la trace de vos insights UX",
  },
  "hero.subtitle": {
    en: "Create your living library of personas and products. Organize, share, leverage, and archive your UX insights, all in one place.",
    fr: "Créez votre bibliothèque de personas et produits vivante. Organisez, partagez, exploitez et archivez vos insights UX, tout en un seul endroit.",
  },
  "hero.aria": {
    en: "Hero",
    fr: "Accroche",
  },
  "hero.signInAria": {
    en: "Get started with Bibliona for free",
    fr: "Commencer gratuitement avec Bibliona",
  },
  "hero.signIn": {
    en: "Get started - it's free",
    fr: "Commencer gratuitement",
  },

  // ─── Many Section ─────────────────────────────────────
  "many.aria": {
    en: "Why use Bibliona",
    fr: "Pourquoi utiliser Bibliona",
  },
  "many.title.prefix": {
    en: "Do you work on many",
    fr: "Vous travaillez sur de nombreux",
  },
  "many.title.personas": {
    en: "personas",
    fr: "personas",
  },
  "many.title.and": {
    en: "and",
    fr: "et",
  },
  "many.title.products": {
    en: "products?",
    fr: "produits ?",
  },
  "many.point1.title": {
    en: "Never miss a key insight",
    fr: "Ne manquez plus aucun insight clé",
  },
  "many.point1.desc": {
    en: "Capture and organize every finding so no user pain point falls through the cracks.",
    fr: "Enregistrez et organisez chaque insight pour qu'aucun pain point utilisateur ne passe entre les mailles.",
  },
  "many.point2.title": {
    en: "One place for all your research",
    fr: "Toute votre recherche au même endroit",
  },
  "many.point2.desc": {
    en: "Stop digging through scattered documents. Find what you need in seconds.",
    fr: "Arrêtez de fouiller dans des documents éparpillés. Trouvez ce qu'il vous faut en quelques secondes.",
  },
  "many.point3.title": {
    en: "Collaborate without friction",
    fr: "Collaborez sans friction",
  },
  "many.point3.desc": {
    en: "Share insights with your team instantly. Collaborations and handovers become effortless.",
    fr: "Partagez vos insights instantanément. La collaboration et les onboardings deviennent un jeu d'enfant.",
  },

  // ─── Features Section ─────────────────────────────────
  "features.title": {
    en: "Features",
    fr: "Fonctionnalités",
  },
  "features.aria.section": {
    en: "Product features",
    fr: "Fonctionnalités du produit",
  },
  "features.aria.list": {
    en: "Features list",
    fr: "Liste des fonctionnalités",
  },
  "features.aria.slides": {
    en: "Feature slides",
    fr: "Diaporama des fonctionnalités",
  },
  "features.slide1.title": {
    en: "Your personas and products, beautifully organized",
    fr: "Vos personas et produits, parfaitement organisés",
  },
  "features.slide1.alt": {
    en: "Bibliona home screen showing persona and product library management",
    fr: "Écran d'accueil Bibliona montrant la gestion de bibliothèque de personas et produits",
  },
  "features.slide2.title": {
    en: "Every insight at your fingertips",
    fr: "Chaque insight à portée de main",
  },
  "features.slide2.alt": {
    en: "Bibliona insights list view for tracking UX research findings",
    fr: "Vue liste des enseignements Bibliona pour suivre les résultats de recherche UX",
  },
  "features.slide3.title": {
    en: "Keep your library clean and up to date",
    fr: "Gardez votre bibliothèque à jour",
  },
  "features.slide3.alt": {
    en: "Bibliona archive feature for managing outdated UX insights",
    fr: "Fonctionnalité d'archivage Bibliona pour gérer les connaissances UX obsolètes",
  },
  "features.slide4.title": {
    en: "Share with your team in one click",
    fr: "Partagez avec votre équipe en un clic",
  },
  "features.slide4.alt": {
    en: "Bibliona sharing and collaboration features for UX teams",
    fr: "Fonctionnalités de partage et collaboration Bibliona pour les équipes UX",
  },

  // ─── Call to Action ───────────────────────────────────
  "cta.aria": {
    en: "Get started with Bibliona",
    fr: "Commencer avec Bibliona",
  },
  "cta.title": {
    en: "Ready to organize your UX research?",
    fr: "Prêt à structurer votre recherche UX ?",
  },
  "cta.planPrefix": {
    en: "Start with the ",
    fr: "Commencez avec l'offre ",
  },
  "cta.free": {
    en: "free plan",
    fr: "gratuite",
  },
  "cta.startFree": {
    en: "Create My Library — Free",
    fr: "Créer ma bibliothèque — Gratuit",
  },
  "cta.seePricing": {
    en: "See pricing",
    fr: "Voir les tarifs",
  },

  // ─── Footer ───────────────────────────────────────────
  "footer.description": {
    en: "Helping UX teams organize and share their research, one insight at a time.",
    fr: "Aidons les équipes UX à organiser et partager leurs recherches, un insight à la fois.",
  },
  "footer.rights": {
    en: "All rights reserved.",
    fr: "Tous droits réservés.",
  },
  "footer.product": {
    en: "Product",
    fr: "Produit",
  },
  "footer.resources": {
    en: "Resources",
    fr: "Ressources",
  },
  "footer.aria": {
    en: "Footer navigation",
    fr: "Navigation du pied de page",
  },

  // ─── Pricing Page ─────────────────────────────────────
  "pricing.title": {
    en: "Pricing",
    fr: "Tarifs",
  },
  "pricing.aria": {
    en: "Pricing plans",
    fr: "Offres tarifaires",
  },
  "pricing.basic": {
    en: "Basic",
    fr: "Basique",
  },
  "pricing.free": {
    en: "Free",
    fr: "Gratuit",
  },
  "pricing.includes": {
    en: "Includes:",
    fr: "Inclus :",
  },
  "pricing.unlimitedProducts": {
    en: "Unlimited Products",
    fr: "Produits illimités",
  },
  "pricing.unlimitedPersonas": {
    en: "Unlimited Personas",
    fr: "Personas illimités",
  },
  "pricing.unlimitedExperiences": {
    en: "Unlimited Experiences",
    fr: "Expériences illimitées",
  },
  "pricing.pro": {
    en: "Pro",
    fr: "Pro",
  },
  "pricing.perMonth": {
    en: "/month",
    fr: "/mois",
  },
  "pricing.select": {
    en: "Select",
    fr: "Choisir",
  },
  "pricing.sharingFeatures": {
    en: "Sharing and collaboration features",
    fr: "Fonctionnalités de partage et collaboration",
  },
  "pricing.enterprise": {
    en: "Enterprise",
    fr: "Entreprise",
  },
  "pricing.perUserMonth": {
    en: "/user/month",
    fr: "/utilisateur/mois",
  },
  "pricing.libraryAccess": {
    en: "Library of Personas and Products accessible to any collaborators",
    fr: "Bibliothèque de personas et produits accessible à tous les collaborateurs",
  },
  "pricing.commonBilling": {
    en: "Common Billing",
    fr: "Facturation commune",
  },
  "pricing.seeFeatures": {
    en: "See features",
    fr: "Voir les fonctionnalités",
  },
  "pricing.contactUs": {
    en: "Contact Us",
    fr: "Nous contacter",
  },
  "pricing.basicAria": {
    en: "Sign in to the free Basic plan",
    fr: "Se connecter à l'offre Basique gratuite",
  },
  "pricing.proAria": {
    en: "Select the Pro plan at $1.99 per month",
    fr: "Choisir l'offre Pro à 1,99 $/mois",
  },
  "pricing.enterpriseAria": {
    en: "Select the Enterprise plan at $19.99 per user per month",
    fr: "Choisir l'offre Entreprise à 19,99 $/utilisateur/mois",
  },
  "pricing.additionalNav": {
    en: "Additional navigation",
    fr: "Navigation complémentaire",
  },

  // ─── 404 Page ─────────────────────────────────────────
  "notFound.title": {
    en: "404 - Page Not Found",
    fr: "404 - Page non trouvée",
  },
  "notFound.description": {
    en: "The page you're looking for no longer exists or has been moved. Try going back or explore our other sections to find what you need.",
    fr: "La page que vous recherchez n'existe plus ou a été déplacée. Essayez de revenir en arrière ou explorez nos autres sections pour trouver ce que vous cherchez.",
  },
  "notFound.goBack": {
    en: "Go Back to Home Page",
    fr: "Retour à l'accueil",
  },

  // ─── SEO ──────────────────────────────────────────────
  "seo.defaultTitle": {
    en: "Bibliona - Persona & Product Library for UX Designers",
    fr: "Bibliona - Bibliothèque de personas et produits pour les UX Designers",
  },
  "seo.defaultDescription": {
    en: "Never lose track of your UX insights again. Build your persona and product library to organize, share, and act on your research — all in one place. Free to start.",
    fr: "Ne perdez plus jamais la trace de vos insights UX. Créez votre bibliothèque de personas et produits pour organiser, partager et exploiter vos recherches — au même endroit. Gratuit pour commencer.",
  },
  "seo.home.description": {
    en: "Never lose track of your UX insights again. Build your persona and product library to organize, share, and act on your research — all in one place. Free to start.",
    fr: "Ne perdez plus jamais la trace de vos insights UX. Créez votre bibliothèque de personas et produits pour organiser, partager et exploiter vos recherches — au même endroit. Gratuit pour commencer.",
  },
  "seo.features.title": {
    en: "Features - Persona & Product Management Tool",
    fr: "Fonctionnalités - Outil de gestion de personas et produits",
  },
  "seo.features.description": {
    en: "Discover Bibliona's features: create persona and product libraries, list and archive your UX insights, and share and collaborate with your team seamlessly.",
    fr: "Découvrez les fonctionnalités de Bibliona : créez des bibliothèques de personas et produits, listez et archivez vos connaissances UX, et collaborez facilement avec votre équipe.",
  },
  "seo.pricing.title": {
    en: "Pricing - Free & Pro Plans for UX Teams",
    fr: "Tarifs - Offres gratuites et Pro pour les équipes UX",
  },
  "seo.pricing.description": {
    en: "Start free with unlimited personas and products. Upgrade to Pro for collaboration features at $1.99/month, or Enterprise for team management at $19.99/user/month.",
    fr: "Commencez gratuitement avec des personas et produits illimités. Passez au Pro pour les fonctionnalités de collaboration à 1,99 $/mois, ou Entreprise pour la gestion d'équipe à 19,99 $/utilisateur/mois.",
  },
  "seo.notFound.title": {
    en: "Page Not Found",
    fr: "Page non trouvée",
  },
  "seo.notFound.description": {
    en: "The page you're looking for no longer exists or has been moved.",
    fr: "La page que vous recherchez n'existe plus ou a été déplacée.",
  },

  // ─── JSON-LD ──────────────────────────────────────────
  "jsonld.home.description": {
    en: "Persona and product library for UX designers and user researchers. Organize, share, and collaborate on your research insights.",
    fr: "Bibliothèque de personas et produits pour les UX designers et chercheurs utilisateurs. Organisez, partagez et collaborez sur vos connaissances.",
  },
  "jsonld.home.basic.description": {
    en: "Free plan with unlimited personas, products, and experiences",
    fr: "Offre gratuite avec personas, produits et expériences illimités",
  },
  "jsonld.home.pro.description": {
    en: "Pro plan with sharing and collaboration features",
    fr: "Offre Pro avec fonctionnalités de partage et collaboration",
  },
  "jsonld.pricing.name": {
    en: "Bibliona Pricing",
    fr: "Tarifs Bibliona",
  },
  "jsonld.pricing.description": {
    en: "Choose the right Bibliona plan for your UX research needs. Free, Pro, and Enterprise options available.",
    fr: "Choisissez l'offre Bibliona adaptée à vos besoins. Options gratuite, Pro et Entreprise disponibles.",
  },
  "jsonld.pricing.basic.description": {
    en: "Free plan with unlimited personas, products, and experiences",
    fr: "Offre gratuite avec personas, produits et expériences illimités",
  },
  "jsonld.pricing.pro.description": {
    en: "Sharing and collaboration features with unlimited resources",
    fr: "Fonctionnalités de partage et collaboration avec ressources illimitées",
  },
  "jsonld.pricing.enterprise.description": {
    en: "Team library, collaboration, common billing, and unlimited resources",
    fr: "Bibliothèque d'équipe, collaboration, facturation commune et ressources illimitées",
  },

  // ─── Persona alt text ─────────────────────────────────
  "personas.alt": {
    en: "Example persona profile",
    fr: "Exemple de profil persona",
  },
  "personas.mainAlt": {
    en: "Bibliona persona and product library dashboard preview",
    fr: "Aperçu du tableau de bord Bibliona de bibliothèque de personas et produits",
  },

  // ─── Open navigation ─────────────────────────────────
  "nav.openMenu": {
    en: "Open navigation menu",
    fr: "Ouvrir le menu de navigation",
  },
  "nav.mainAria": {
    en: "Main navigation",
    fr: "Navigation principale",
  },
};

export default translations;
